import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_PLYWOOD_BRANDS);

const BCMBrandPlywood = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_PLYWOOD_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['Century Ply', 'Greenply', 'Kitply', 'National Plywood', 'Austin Plywood']}
      icon={PROFILER_IMAGES.plywood}
      {...props}
    />
  )
}

export default BCMBrandPlywood
